import { invariant as t } from "./atoms-v2886.js";
import { noop as i } from "./atoms-v2887.js";
import { isBezierDefinition as m } from "./atoms-v21110.js";
import { anticipate as u } from "./atoms-v2893.js";
import { backIn as s, backInOut as p, backOut as f } from "./atoms-v2894.js";
import { circIn as I, circInOut as b, circOut as l } from "./atoms-v2895.js";
import { cubicBezier as O } from "./atoms-v2983.js";
import { easeIn as g, easeInOut as y, easeOut as k } from "./atoms-v2974.js";
const e = {
  linear: i,
  easeIn: g,
  easeInOut: y,
  easeOut: k,
  circIn: I,
  circInOut: b,
  circOut: l,
  backIn: s,
  backInOut: p,
  backOut: f,
  anticipate: u
}, L = (r) => {
  if (m(r)) {
    t(r.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [o, a, n, c] = r;
    return O(o, a, n, c);
  } else if (typeof r == "string")
    return t(e[r] !== void 0, `Invalid easing type '${r}'`), e[r];
  return r;
};
export {
  L as easingDefinitionToFunction
};
